import Alternative, { AlternativeRaw, AlternativeStatus } from './alternative';
import Model from '../../common/model/model';

export interface QuizRaw {
  id: number;
  title: string;
  content?: string;
  activityId: number;
  alternatives: AlternativeRaw[];
  done: boolean;
}

export default class Quiz extends Model<QuizRaw> {
  public getTitle() {
    return this.raw.title;
  }

  public getContent() {
    return this.raw.content;
  }

  public getActivityId() {
    return this.raw.activityId;
  }

  public getAlternatives() {
    return this.raw.alternatives.map(
      alternative => new Alternative(alternative),
    );
  }

  public getCorrectAlternative() {
    return this.raw.alternatives.find(a => a.status === 'correct');
  }

  public getAlternativeById(id: number) {
    return this.raw.alternatives.find(a => a.id === id);
  }

  public updateAlternativeStatus(
    alternativeId: number,
    status: AlternativeStatus,
  ) {
    this.raw.alternatives = this.raw.alternatives.map(a => ({
      ...a,
      status: a.id === alternativeId ? status : 'empty',
    }));
  }

  public isDone() {
    return this.raw.done;
  }

  public reset() {
    this.raw.alternatives.forEach(a => {
      a.status = 'empty';
    });
    this.raw.done = false;
  }

  public setDone(done: boolean) {
    this.raw.done = done;
  }

  public toJson() {
    return this.raw;
  }
}
